module.exports = __webpack_public_path__ + "static/media/arts_3.e5cbe29a.jpg";